import * as React from 'react';
import { useTheme } from '../../../theme';
import cn from 'classnames';
const SummaryGroup = ({ className, children }) => {
    const theme = useTheme('PaymentForm').Summary;
    return React.createElement("div", { className: cn(theme.group, className) }, children);
};
export default SummaryGroup;
